import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { resetBooking } from '../../dashboard/booking/actions';
import FontAwesome from 'react-fontawesome';

class BookWorkshop extends Component {

	componentDidMount() {
		const { isAuthenticated, history, centerId, workshopId, resetBooking } = this.props;

		if (isAuthenticated) {
			history.replace(`/workshop/booking/${centerId}/${workshopId}/child?reset=true`);
		} else {
			resetBooking();
			history.replace(`/public/workshops/${centerId}/${workshopId}/sessions`);
		}
	}

	render() {
		return <div style={{ textAlign: 'center', fontSize: '16px', color: '#0071ac' }}>
			<FontAwesome name='spinner' spin size='3x' />
		</div>;
	}
}

const mapStateToProps = (state, ownProps) => {
	const centerId = Number(ownProps.match.params.centerId);
	const workshopId = Number(ownProps.match.params.workshopId);

	const { auth: { isAuthenticated } } = state;

	return {
		isAuthenticated,
		centerId,
		workshopId
	};
};

export default connect(mapStateToProps, {
	resetBooking
})(withTranslation()(BookWorkshop));